import React, { memo } from "react";
import { formatItemYear } from "../../services/formatItemYear";

const cleanValue = (value) => {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  return text && text.toLowerCase() !== "unknown" ? text : "";
};

const ItemCard = memo(
  ({
    card,
    index,
    isSelected,
    multiSelectMode,
    handleCardClick,
    handleTouchStart,
    handleTouchEnd,
  }) => {
    const firstImage = card.images?.[0];
    const mainImage =
      card.image_url ||
      (typeof firstImage === "string"
        ? firstImage
        : firstImage?.image_url || firstImage?.url || null);

    const year = cleanValue(formatItemYear(card.year, card.year_end));
    const brand = cleanValue(card.brand);
    const setName = cleanValue(card.set_name);
    const subset = cleanValue(card.subset);
    const identityParts = [year, brand, setName, subset].filter(Boolean);
    const identityLine = identityParts.join(" · ");

    return (
      <div
        className={`item-card ${isSelected && multiSelectMode ? "selected" : ""}`}
        onClick={(event) => handleCardClick(index, card, event)}
        onTouchStart={() => handleTouchStart(index, card)}
        onTouchEnd={handleTouchEnd}
      >
        <div className="item-card-image-shell">
          {mainImage ? (
            <img src={mainImage} alt={card.name || "Collection item"} />
          ) : card._optimistic ? (
            <div className="placeholder">
              <div className="spinner" />
            </div>
          ) : (
            <div className="placeholder">No Image</div>
          )}

          {isSelected && multiSelectMode && <div className="checkmark">✓</div>}
        </div>

        <div className="info">
          <strong className="item-card-name" title={card.name || ""}>
            {card.name || "Untitled item"}
          </strong>

          {identityLine && (
            <div className="item-card-identity" title={identityLine}>
              {identityParts.map((part, partIndex) => (
                <React.Fragment key={`${part}-${partIndex}`}>
                  {partIndex > 0 && (
                    <span className="item-card-identity-separator" aria-hidden="true">
                      ·
                    </span>
                  )}
                  <span className="item-card-identity-part">{part}</span>
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
);

ItemCard.displayName = "ItemCard";

export default ItemCard;
